<template>
	<div>
		<label
			v-if="label_prop"
			class="label">
			<span
				class="icon has-text-grey is-inline"
				data-tippy
				><i class="is-inline fas fa-info-circle m-0 p-0"></i
				>&nbsp;&nbsp;</span
			>
			<span v-html="label"></span>
			<span
				v-if="in_bracket() !== ''"
				class="has-text-grey"
				>({{ in_bracket() }})</span
			>
			<span class="has-text-weight-normal is-size-7">{{
				"(" + currentInputLength + " / " + maxInputLength + ")"
			}}</span>
		</label>
		<div class="control">
			<input
				v-if="type != 'textarea'"
				v-model="inputValue"
				class="input"
				:type="type"
				name="name"
				:placeholder="placeholder"
				:maxlength="maxInputLength" />
			<textarea
				v-else
				v-model="inputValue"
				class="textarea"
				name="name"
				:placeholder="placeholder"
				rows="6"
				:maxlength="maxInputLength"></textarea>
		</div>
	</div>
</template>
<style type="text/css" scoped></style>
<script type="text/javascript">
	import tippy from "tippy.js";
	import "tippy.js/dist/tippy.css";

	export default {
		props: {
			label_prop: String,
			description_prop: String,
			limit_prop: Number,
			type_prop: String,
			placeholder_prop: String,
			required_prop: Boolean,
			optional_prop: Boolean,
			recommended_prop: Boolean,
			bracket_text_prop: String,
		},
		mounted() {
			tippy("[data-tippy]", {
				content: this.description,
				trigger: "click",
				allowHTML: true,
			});
		},
		data() {
			return {
				inputValue: "",
			};
		},
		computed: {
			label() {
				return this.label_prop ? this.label_prop : "";
			},
			description() {
				return this.description_prop
					? this.description_prop
					: "*Blank Description*";
			},
			placeholder() {
				return this.placeholder_prop ? this.placeholder_prop : "";
			},
			optional() {
				return this.optional_prop ? true : false;
			},
			recommended() {
				return this.recommended_prop ? true : false;
			},
			required() {
				return this.required_prop ? true : false;
			},
			bracket_text() {
				return this.bracket_text_prop ? this.bracket_text_prop : "";
			},
			type() {
				switch (this.type_prop) {
					case "text":
					case "textarea":
					case "number":
						return this.type_prop;
						break;
					default:
						return "text";
				}
			},
			maxInputLength() {
				return this.limit_prop ? this.limit_prop : 50;
			},
			currentInputLength() {
				return this.inputValue.length;
			},
		},
		methods: {
			value(value) {
				if (value) {
					this.inputValue = value;
					return;
				}
				return this.inputValue;
			},
			clear() {
				this.inputValue = "";
			},
			in_bracket() {
				let in_bracket = [];
				let text = "";
				let t = this;
				if (this.bracket_text) {
					return this.bracket_text;
				}
				if (this.required) {
					return "Required";
				}
				if (this.optional) {
					in_bracket.push("Optional");
				}
				if (this.recommended) {
					in_bracket.push("Recommended");
				}
				in_bracket.forEach((item, index) => {
					text += `${item}`;
					if (in_bracket.length > 1 && index != in_bracket.length - 1) {
						text += " • ";
					}
				});
				return text;
			},
		},
	};
</script>
